export const subscriptionTypeConstants = {
  MEMEBER_SHIP: 0,
  SAILING: 1,
  KITE_SURFING: 2,
  WING_FOILING: 3,
  WIND_SURFING: 4,
  VAT: 5,
  SAILING_TEXT: "Sailing",
  KITE_SURFING_Text: "Kite Surfing",
  WING_FOILING_Text: "Wing Foiling",
  WIND_SURFING_Text: "Wind Surfing",
  VAT_Text: "VAT",
};
